import { useSelector } from 'react-redux';

import { selectAuthenticationContext } from '../../selectors/authenticationContext.selectors';
import type { AuthenticationContext } from '../../types/authenticationContext.types';

//keep this for backwards compatibility
export const useAuth0 = (): AuthenticationContext =>
	useSelector(selectAuthenticationContext);
